<template>
    <div class="pagination-wrapper" v-if="playerSessions.length">
        <div class="rows-per-page">
            <span class="show-per-page">{{ $t('SESSION_HISTORY.pagination.showPerPage')}}:</span>
            <b-dropdown id="ddown1" class="btn-group dropdown auto-height">
                <template slot="button-content">
                    {{paginationCriteria.pageSize}}
                </template>

                <b-dropdown-item v-for="(size, i) in pageSizes" :key="i" @click="onPageSizeChange(size)">
                <span class="text-ellipsis-overflow" :class="size == paginationCriteria.pageSize ? 'active-size': 'disabled'">{{size}}</span>
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="paging-section">
            <ul class="pagination">
                <li class="pagination-first" :class="this.paginationCriteria.pageNum == 0 ? 'disabled' : 'active'">
                    <a @click="goToFirstLast(false)">
                        <img src="@/assets/images/icons/double-arrow-icon.png" alt="double arrow">
                    </a>
                </li>
                <li class="pagination-prev" :class="this.paginationCriteria.pageNum == 0 ? 'disabled' : 'active'">
                    <a @click="triggerPageChange(false)">
                        <img src="@/assets/images/icons/arrow-left-icon.png" alt="left arrow">
                    </a>
                </li>
                <li class="pagination-page">
                    <a>{{paginationCriteria.pageNum +1 }} - {{Math.ceil(playerInfo.totalActivitiesCount / paginationCriteria.pageSize)}}</a>
                </li>
                <li class="pagination-next" :class="this.paginationCriteria.pageNum + 1 == this.totalPages.total ? 'disabled' : 'active'">
                    <!-- <a @click="onPageChange(paginationCriteria.pageNum + 1)"> -->
                    <a @click="triggerPageChange(true)">
                    <img src="@/assets/images/icons/arrow-left-icon.png" alt="left arrow" class="next-page">
                    </a>
                </li>
                <li class="pagination-last" :class="this.paginationCriteria.pageNum + 1 == this.totalPages.total ? 'disabled' : 'active'">
                    <a @click="goToFirstLast(true)">
                        <img src="@/assets/images/icons/double-arrow-icon.png" alt="double arrow" class="last-page">
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SessionHistoryPagination',
  props: {
    onPageChange : Function,
    paginationCriteria : Object ,
    playerSessions : Array,
    pageSizes : Array,
    onPageSizeChange : Function,
    playerInfo : Object,
    totalPages : Object
  },
  methods: {
    triggerPageChange (isIncreasing) {
      if (isIncreasing) {
        if (this.paginationCriteria.pageNum + 1 < this.totalPages.total) {
          this.onPageChange(this.paginationCriteria.pageNum + 1)
        }
      } else {
        if (this.paginationCriteria.pageNum > 0) {
          this.onPageChange(this.paginationCriteria.pageNum - 1)
        }
      }
    },
    goToFirstLast (isIncreasing) {
      if (isIncreasing) {
        if (this.paginationCriteria.pageNum + 1 < this.totalPages.total) {
          this.onPageChange(this.totalPages.total - 1)
        }
      } else {
        if (this.paginationCriteria.pageNum > 0) {
          this.onPageChange(0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .active-size{
        color: white;
    }
    .pagination-wrapper {
        display: inline-block;
        width: 100%;
        padding: 20px;
        background-color: #090909;
        font-size: 14px;
        .rows-per-page {
            float: left;
        }
        .pagging-section {
            float: right;
            vertical-align: top;
            margin-top: 5px;
        }
        .show-per-page {
            float: left;
            margin-top: 5px;
            margin-right: 10px;
        }

        .paging-section {
            float: right;
            vertical-align: top;
            margin-top: 5px;

            .pagination-first, .pagination-prev, .pagination-next, .pagination-last {
                cursor: pointer;
            }
        }
    }

    @media (max-width: 480px){
        .pagination-wrapper {
            text-align: center;
            .rows-per-page {
                margin-bottom: 20px;
                display: block;
                float: none;
                .show-per-page {
                    float: none;
                }
            }

            .paging-section {
                display: inline-block;
                float: none;
                .pagination {
                    float: none;
                }
            }
        }
    }
</style>
